export default (margin, precision) => (item) => ({
  quote: item.itemId,
  supplier: item.quotation.supplier,
  item: item.quotation.itemId,
  price: item.quotation.price,
  isPriceGuaranted: !!item.quotation.isPriceGuaranted,
  proposalPrice: (item.quotation.price * ((margin / 100) + 1)).toFixed(precision),
  minimumPrice: (item.quotation.price * ((margin / 100) + 1)).toFixed(precision)
})



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/MapToChoiceQuotation.js